import * as React from 'react';

const InnerLoader = () => {
    return (
        <div className="inner-loader">
            <div className="lds-dual-ring"/>
        </div>
    );
};

export default InnerLoader;



// WEBPACK FOOTER //
// ./src/modules/InnerLoader/InnerLoader.tsx